'use client';

import { useQuery } from '@tanstack/react-query';

import { AuthApi, UnauthApi } from '@/api';
import { ROUTES } from '@/constants';
import { DEFAULT_LOCATION } from '@/hooks/useLocation';
import { useAuthStore } from '@/stores/AuthStore';

import { RealtimeRegionInfoClient } from './RealtimeRegionInfoClient';

export const RealtimeRegionInfoSection = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const codeRegion = useAuthStore(
    (state) => state.myInfo?.codeRegion ?? DEFAULT_LOCATION.codeRegion,
  );
  const codeSubRegion = useAuthStore(
    (state) => state.myInfo?.codeSubRegion ?? DEFAULT_LOCATION.codeSubRegion,
  );

  const { data: response } = useQuery({
    queryKey: ['realtime-hometown-news', isLogin, codeRegion, codeSubRegion],
    queryFn: () =>
      isLogin
        ? AuthApi['get:/wello/v2/auth/hometown-news']({
            query: {
              page: 1,
              size: 3,
              hometownNewsSort: 'LATEST',
              codeRegion: codeRegion,
              codeSubRegion: codeSubRegion,
            },
            cache: 'no-store', // 사용자별 맞춤 데이터 - 캐시 안 함
          })
        : UnauthApi['get:/wello/v2/allows/hometown-news']({
            query: {
              page: 1,
              size: 3,
              hometownNewsSort: 'LATEST',
              codeRegion: codeRegion,
              codeSubRegion: codeSubRegion,
            },
            cache: 'no-store', // 사용자별 맞춤 데이터 - 캐시 안 함
          }),
  });

  const newsItems = response?.data?.context?.contents || [];

  if (newsItems.length === 0) {
    return null;
  }

  // 최신 뉴스의 업데이트 시간 (첫 번째 아이템 기준)
  const updatedAt = newsItems[0]?.daysAgo || '';

  const news = newsItems.map((item) => ({
    id: item.hometownNewsId || 0,
    text: item.hometownNewsName || '',
    href: ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
      idIdx: item.hometownNewsIdIdx || '',
    }),
  }));

  return (
    <RealtimeRegionInfoClient
      isLogin={!!isLogin}
      updatedAt={updatedAt}
      news={news}
    />
  );
};
